// FT3D party vote — the campaign-channel relay for the GM's table poll.
//
// This bundle only routes: the panel itself lives in campaign-init/ft3d-party-vote.ts, which
// listens for the event raised here. Same split as ft3d-player-presence.ts.

import type { WSMessage } from './types';
import { handleRollInsert } from './roll-insert';

type PartyVoteMessage = Extract<WSMessage, { type: 'ft3d_party_vote' }>;
const beforeMount: PartyVoteMessage[] = [];

export function handleFt3dPartyVote(message: PartyVoteMessage): void {
    if (message.schema !== 'ft.ft3d.party-vote.v1') return;
    if (document.querySelector<HTMLElement>('[data-ft3d-campaign-encounter-view]')?.dataset.ft3dPartyVoteMounted !== '1') {
        beforeMount.push(message);
        return;
    }
    const currentCampaignId = String(window.FateTide?.campaign?.id ?? '').trim().toUpperCase();
    if (!currentCampaignId || String(message.campaign_id ?? '').trim().toUpperCase() !== currentCampaignId) return;
    const frame = message as unknown as Record<string, any>;
    if (frame.log && Number(frame.now) + Number(frame.transport_replay_age_ms ?? 0) / 1000 - Number(frame.poll?.closedAt) < 9)
        void handleRollInsert({ type: 'roll_insert', roll: frame.log, encounter_id: frame.log.encounter_id });
    window.dispatchEvent(new CustomEvent<PartyVoteMessage>('ft3d-party-vote-message', {
        detail: message,
    }));
}

window.handleFt3dPartyVote = handleFt3dPartyVote;
Object.assign(window, { ftDrainPartyVoteMessages: (): void => {
    for (const message of beforeMount.splice(0)) handleFt3dPartyVote(message);
} });
